/**
 * Loyalty Service
 * API methods for loyalty/wallet operations (requires authentication)
 */

import api from '../utils/api';

export const loyaltyService = {
  /**
   * Get customer's wallet
   * @returns {Promise} API response with wallet data
   */
  getMyWallet: () => {
    return api.get('/loyalty/my-wallet');
  },

  /**
   * Get customer's wallet transactions
   * @param {Object} params - Query parameters (page, limit, type, startDate, endDate)
   * @returns {Promise} API response with transaction list
   */
  getMyTransactions: (params) => {
    return api.get('/loyalty/my-transactions', { params });
  },

  /**
   * Validate redemption before checkout
   * @param {Object} data - { orderTotal, pointsToRedeem, appliedOfferId }
   * @returns {Promise} API response with validation result
   */
  validateRedemption: (data) => {
    return api.post('/loyalty/validate-redemption', data);
  },
};

export default loyaltyService;
